"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParticipantChatBubble = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const chat_helpers_1 = require("@/components/domains/chat/chat.helpers");
const chat_styles_1 = require("@/components/domains/chat/chat.styles");
/**
 * 다중 채팅 참여자가 보낸 메시지 버블. 좌측 정렬 + subtle 배경.
 */
let ParticipantChatBubble = class ParticipantChatBubble extends (0, chat_helpers_1.withChatBubbleImage)(lit_1.LitElement) {
    render() {
        return (0, chat_helpers_1.renderChatBubbleShell)(this, (0, lit_1.html) `
        <slot></slot>
      `);
    }
};
ParticipantChatBubble.styles = [chat_styles_1.chatBubbleStyles, chat_styles_1.participantChatBubbleStyles];
ParticipantChatBubble = __decorate([
    (0, decorators_js_1.customElement)('mm-participant-chat-bubble')
], ParticipantChatBubble);
exports.ParticipantChatBubble = ParticipantChatBubble;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFydGljaXBhbnQtY2hhdC1idWJibGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJwYXJ0aWNpcGFudC1jaGF0LWJ1YmJsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBc0M7QUFDdEMscURBQWlEO0FBRWpELHlFQUFtRztBQUNuRyx1RUFHOEM7QUFFOUM7O0dBRUc7QUFFSSxJQUFNLHFCQUFxQixHQUEzQixNQUFNLHFCQUFzQixTQUFRLElBQUEsa0NBQW1CLEVBQUMsZ0JBQVUsQ0FBQztJQUd4RSxNQUFNO1FBQ0osT0FBTyxJQUFBLG9DQUFxQixFQUMxQixJQUFJLEVBQ0osSUFBQSxVQUFJLEVBQUE7O09BRUgsQ0FDRixDQUFBO0lBQ0gsQ0FBQzs7QUFUTSw0QkFBTSxHQUFHLENBQUMsOEJBQWdCLEVBQUUseUNBQTJCLENBQUMsQ0FBQTtBQURwRCxxQkFBcUI7SUFEakMsSUFBQSw2QkFBYSxFQUFDLDRCQUE0QixDQUFDO0dBQy9CLHFCQUFxQixDQVdqQztBQVhZLHNEQUFxQiJ9